import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Navigation
    nav: {
      feed: 'Feed',
      search: 'Buscar',
      appointments: 'Citas',
      messages: 'Mensajes',
      upload: 'Subir',
      quotes: 'Cotizaciones',
      profile: 'Mi Perfil',
      logout: 'Cerrar Sesión',
      notifications: 'Notificaciones',
    },
    // Landing
    landing: {
      tagline: 'La red social para tatuadores',
      heroTitle: 'TU ARTE.',
      heroTitle2: 'TU COMUNIDAD.',
      heroSubtitle: 'Conecta con clientes, gestiona tu agenda y comparte tu trabajo con la comunidad de tatuadores más grande.',
      getStarted: 'Comenzar Ahora',
      exploreArtists: 'Explorar Artistas',
      discoverMore: 'Descubre más',
      features: 'Características',
      featuresTitle: 'TODO LO QUE NECESITAS',
      gallery: 'Galería',
      galleryTitle: 'ARTE QUE INSPIRA',
      joinTitle: 'ÚNETE A LA COMUNIDAD',
      joinSubtitle: 'Miles de tatuadores ya están compartiendo su arte y conectando con nuevos clientes.',
      createAccount: 'Crear Cuenta Gratis',
      login: 'Iniciar Sesión',
      digitalPortfolio: 'Portfolio Digital',
      digitalPortfolioDesc: 'Muestra tu arte al mundo con una galería profesional',
      appointmentMgmt: 'Gestión de Citas',
      appointmentMgmtDesc: 'Organiza tu agenda y gestiona reservas fácilmente',
      directChat: 'Chat Directo',
      directChatDesc: 'Comunícate con clientes de forma privada y segura',
      socialMedia: 'Redes Sociales',
      socialMediaDesc: 'Comparte tu trabajo directamente a tus redes',
    },
    // Auth
    auth: {
      welcome: 'BIENVENIDO',
      join: 'ÚNETE',
      loginSubtitle: 'Ingresa a tu cuenta para continuar',
      registerSubtitle: 'Crea una cuenta para empezar',
      accountType: '¿Qué tipo de cuenta?',
      artist: 'TATUADOR',
      artistDesc: 'Comparte tu trabajo',
      client: 'CLIENTE',
      clientDesc: 'Encuentra artistas',
      artistName: 'Nombre artístico',
      fullName: 'Nombre completo',
      email: 'Email',
      password: 'Contraseña',
      location: 'Ubicación',
      createAccount: 'Crear Cuenta',
      loginBtn: 'Iniciar Sesión',
      noAccount: '¿No tienes cuenta? Regístrate',
      hasAccount: '¿Ya tienes cuenta? Inicia sesión',
      changeAccountType: '← Cambiar tipo de cuenta',
      back: 'Volver',
    },
    // Feed
    feed: {
      welcome: 'BIENVENIDO A INKER',
      artistEmpty: '¡Comienza subiendo tu primer trabajo!',
      clientEmpty: 'Explora y encuentra tatuadores increíbles',
      uploadArt: 'Subir Arte',
      searchArtists: 'Buscar Artistas',
    },
    // Profile
    profile: {
      artist: 'Tatuador',
      client: 'Cliente',
      works: 'Trabajos',
      followers: 'Seguidores',
      following: 'Siguiendo',
      reviews: 'Reseñas',
      editProfile: 'Editar Perfil',
      follow: 'Seguir',
      unfollow: 'Siguiendo',
      requestAppointment: 'Solicitar Cita',
      requestQuote: 'Pedir Cotización',
      gallery: 'Galería',
      noWorks: 'No has subido ningún trabajo aún',
      noWorksOther: 'Este artista no tiene trabajos publicados',
      uploadFirst: 'Subir tu primer trabajo',
      writeReview: 'Escribir Reseña',
      yourRating: 'Tu calificación',
      yourComment: 'Tu comentario (opcional)',
      shareExperience: 'Comparte tu experiencia...',
      publishReview: 'Publicar Reseña',
      noReviews: 'Aún no hay reseñas',
      beFirst: '¡Sé el primero en dejar una reseña!',
    },
    // Search
    search: {
      title: 'ENCUENTRA TU ARTISTA',
      subtitle: 'Busca entre nuestra comunidad de tatuadores por nombre, estilo o ubicación',
      searchByName: 'Buscar por nombre...',
      tattooStyle: 'Estilo de tatuaje',
      allStyles: 'Todos los estilos',
      locationPlaceholder: 'Ubicación...',
      clearFilters: 'Limpiar filtros',
      noResults: 'No se encontraron artistas',
      tryOther: 'Intenta con otros filtros de búsqueda',
      artistsFound: 'artista(s) encontrado(s)',
      works: 'trabajos',
    },
    // Appointments
    appointments: {
      title: 'AGENDA',
      subtitle: 'Gestiona tus citas y reservas',
      myAppointments: 'MIS CITAS',
      myAppointmentsSubtitle: 'Tus solicitudes y citas programadas',
      requests: 'Solicitudes',
      confirmedAppointments: 'Citas Confirmadas',
      newAppointment: 'Nueva Cita',
      pendingRequests: 'Solicitudes Pendientes',
      previousRequests: 'Solicitudes Anteriores',
      noAppointments: 'No hay citas para este día',
      noConfirmed: 'No tienes citas confirmadas',
      noPending: 'No hay solicitudes pendientes',
      respond: 'Responder',
      accept: 'Aceptar',
      reject: 'Rechazar',
      clientName: 'Nombre del cliente',
      clientEmail: 'Email del cliente',
      date: 'Fecha',
      time: 'Hora',
      duration: 'Duración',
      description: 'Descripción',
      createAppointment: 'Crear Cita',
      confirmed: 'Confirmada',
      completed: 'Completada',
      cancelled: 'Cancelada',
      pending: 'Pendiente',
      accepted: 'Aceptada',
      rejected: 'Rechazada',
    },
    // Messages
    messages: {
      title: 'MENSAJES',
      noConversations: 'No tienes conversaciones aún',
      visitProfile: 'Visita el perfil de un artista para enviar un mensaje',
      selectConversation: 'Selecciona una conversación',
      typeMessage: 'Escribe un mensaje...',
    },
    // Upload
    upload: {
      title: 'SUBIR TRABAJO',
      subtitle: 'Comparte tu arte con la comunidad',
      imageLabel: 'Imagen del tatuaje',
      clickToSelect: 'Haz clic para seleccionar una imagen',
      maxSize: 'JPG, PNG o WEBP (máx. 10MB)',
      titleLabel: 'Título',
      titlePlaceholder: 'Nombre de tu trabajo',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Cuéntanos sobre este trabajo...',
      styleLabel: 'Estilo',
      selectStyle: 'Selecciona un estilo',
      tagsLabel: 'Etiquetas',
      tagsPlaceholder: 'flores, manga, brazo (separadas por coma)',
      publish: 'Publicar Trabajo',
      publishing: 'Publicando...',
      artistOnly: 'Sección solo para tatuadores',
      artistOnlyDesc: 'Esta función está disponible únicamente para cuentas de tatuadores.',
    },
    // Quotes
    quotes: {
      title: 'COTIZACIONES',
      subtitle: 'Solicita y gestiona cotizaciones de tatuajes',
      newQuote: 'Nueva Cotización',
      myQuotes: 'Mis Cotizaciones',
      pendingQuotes: 'Cotizaciones Pendientes',
      respondedQuotes: 'Cotizaciones Respondidas',
      noQuotes: 'No tienes cotizaciones',
      requestQuote: 'Solicitar Cotización',
      describeIdea: 'Describe tu idea',
      descriptionPlaceholder: 'Describe el tatuaje que quieres: diseño, significado, referencias...',
      bodyPart: 'Parte del cuerpo',
      bodyPartPlaceholder: 'Ej: antebrazo, espalda, muslo...',
      approximateSize: 'Tamaño aproximado',
      sizePlaceholder: 'Ej: 10x10cm, medio brazo...',
      preferredStyle: 'Estilo preferido',
      sendRequest: 'Enviar Solicitud',
      respondToQuote: 'Responder Cotización',
      priceRange: 'Rango de precio',
      minPrice: 'Precio mínimo',
      maxPrice: 'Precio máximo',
      estimatedSessions: 'Sesiones estimadas',
      estimatedHours: 'Horas estimadas',
      messageToClient: 'Mensaje para el cliente',
      messagePlaceholder: 'Incluye detalles sobre el proceso, materiales, etc.',
      sendQuote: 'Enviar Cotización',
      acceptQuote: 'Aceptar Cotización',
      rejectQuote: 'Rechazar',
      quoteAccepted: 'Cotización Aceptada',
      quoteRejected: 'Cotización Rechazada',
      waitingResponse: 'Esperando respuesta del artista',
      priceLabel: 'Precio estimado',
      sessionsLabel: 'Sesiones',
      hoursLabel: 'Horas por sesión',
    },
    // Notifications
    notifications: {
      title: 'Notificaciones',
      markAllRead: 'Marcar todas como leídas',
      noNotifications: 'No tienes notificaciones',
      viewMore: 'Ver más →',
    },
    // Common
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      send: 'Enviar',
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      confirm: 'Confirmar',
      select: 'Seleccionar',
      optional: 'opcional',
      required: 'requerido',
    },
    // Tattoo styles
    styles: {
      traditional: 'Tradicional',
      neoTraditional: 'Neo-Tradicional',
      realism: 'Realismo',
      blackwork: 'Blackwork',
      dotwork: 'Dotwork',
      japanese: 'Japonés',
      tribal: 'Tribal',
      minimalist: 'Minimalista',
      watercolor: 'Acuarela',
      geometric: 'Geométrico',
      chicano: 'Chicano',
      lettering: 'Lettering',
    },
  },
  en: {
    // Navigation
    nav: {
      feed: 'Feed',
      search: 'Search',
      appointments: 'Appointments',
      messages: 'Messages',
      upload: 'Upload',
      quotes: 'Quotes',
      profile: 'My Profile',
      logout: 'Log Out',
      notifications: 'Notifications',
    },
    // Landing
    landing: {
      tagline: 'The social network for tattoo artists',
      heroTitle: 'YOUR ART.',
      heroTitle2: 'YOUR COMMUNITY.',
      heroSubtitle: 'Connect with clients, manage your schedule and share your work with the largest tattoo artist community.',
      getStarted: 'Get Started',
      exploreArtists: 'Explore Artists',
      discoverMore: 'Discover more',
      features: 'Features',
      featuresTitle: 'EVERYTHING YOU NEED',
      gallery: 'Gallery',
      galleryTitle: 'INSPIRING ART',
      joinTitle: 'JOIN THE COMMUNITY',
      joinSubtitle: 'Thousands of tattoo artists are already sharing their art and connecting with new clients.',
      createAccount: 'Create Free Account',
      login: 'Log In',
      digitalPortfolio: 'Digital Portfolio',
      digitalPortfolioDesc: 'Showcase your art to the world with a professional gallery',
      appointmentMgmt: 'Appointment Management',
      appointmentMgmtDesc: 'Organize your schedule and manage bookings easily',
      directChat: 'Direct Chat',
      directChatDesc: 'Communicate with clients privately and securely',
      socialMedia: 'Social Media',
      socialMediaDesc: 'Share your work directly to your networks',
    },
    // Auth
    auth: {
      welcome: 'WELCOME',
      join: 'JOIN US',
      loginSubtitle: 'Log in to your account to continue',
      registerSubtitle: 'Create an account to get started',
      accountType: 'What type of account?',
      artist: 'TATTOO ARTIST',
      artistDesc: 'Share your work',
      client: 'CLIENT',
      clientDesc: 'Find artists',
      artistName: 'Artist name',
      fullName: 'Full name',
      email: 'Email',
      password: 'Password',
      location: 'Location',
      createAccount: 'Create Account',
      loginBtn: 'Log In',
      noAccount: "Don't have an account? Sign up",
      hasAccount: 'Already have an account? Log in',
      changeAccountType: '← Change account type',
      back: 'Back',
    },
    // Feed
    feed: {
      welcome: 'WELCOME TO INKER',
      artistEmpty: 'Start by uploading your first work!',
      clientEmpty: 'Explore and find amazing tattoo artists',
      uploadArt: 'Upload Art',
      searchArtists: 'Search Artists',
    },
    // Profile
    profile: {
      artist: 'Tattoo Artist',
      client: 'Client',
      works: 'Works',
      followers: 'Followers',
      following: 'Following',
      reviews: 'Reviews',
      editProfile: 'Edit Profile',
      follow: 'Follow',
      unfollow: 'Following',
      requestAppointment: 'Request Appointment',
      requestQuote: 'Request Quote',
      gallery: 'Gallery',
      noWorks: "You haven't uploaded any work yet",
      noWorksOther: "This artist hasn't published any works",
      uploadFirst: 'Upload your first work',
      writeReview: 'Write Review',
      yourRating: 'Your rating',
      yourComment: 'Your comment (optional)',
      shareExperience: 'Share your experience...',
      publishReview: 'Publish Review',
      noReviews: 'No reviews yet',
      beFirst: 'Be the first to leave a review!',
    },
    // Search
    search: {
      title: 'FIND YOUR ARTIST',
      subtitle: 'Search our community of tattoo artists by name, style or location',
      searchByName: 'Search by name...',
      tattooStyle: 'Tattoo style',
      allStyles: 'All styles',
      locationPlaceholder: 'Location...',
      clearFilters: 'Clear filters',
      noResults: 'No artists found',
      tryOther: 'Try different search filters',
      artistsFound: 'artist(s) found',
      works: 'works',
    },
    // Appointments
    appointments: {
      title: 'SCHEDULE',
      subtitle: 'Manage your appointments and bookings',
      myAppointments: 'MY APPOINTMENTS',
      myAppointmentsSubtitle: 'Your requests and scheduled appointments',
      requests: 'Requests',
      confirmedAppointments: 'Confirmed Appointments',
      newAppointment: 'New Appointment',
      pendingRequests: 'Pending Requests',
      previousRequests: 'Previous Requests',
      noAppointments: 'No appointments for this day',
      noConfirmed: "You don't have confirmed appointments",
      noPending: 'No pending requests',
      respond: 'Respond',
      accept: 'Accept',
      reject: 'Reject',
      clientName: 'Client name',
      clientEmail: 'Client email',
      date: 'Date',
      time: 'Time',
      duration: 'Duration',
      description: 'Description',
      createAppointment: 'Create Appointment',
      confirmed: 'Confirmed',
      completed: 'Completed',
      cancelled: 'Cancelled',
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
    },
    // Messages
    messages: {
      title: 'MESSAGES',
      noConversations: "You don't have conversations yet",
      visitProfile: "Visit an artist's profile to send a message",
      selectConversation: 'Select a conversation',
      typeMessage: 'Type a message...',
    },
    // Upload
    upload: {
      title: 'UPLOAD WORK',
      subtitle: 'Share your art with the community',
      imageLabel: 'Tattoo image',
      clickToSelect: 'Click to select an image',
      maxSize: 'JPG, PNG or WEBP (max. 10MB)',
      titleLabel: 'Title',
      titlePlaceholder: 'Name of your work',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Tell us about this work...',
      styleLabel: 'Style',
      selectStyle: 'Select a style',
      tagsLabel: 'Tags',
      tagsPlaceholder: 'flowers, anime, arm (comma separated)',
      publish: 'Publish Work',
      publishing: 'Publishing...',
      artistOnly: 'Tattoo artists only',
      artistOnlyDesc: 'This feature is only available for tattoo artist accounts.',
    },
    // Quotes
    quotes: {
      title: 'QUOTES',
      subtitle: 'Request and manage tattoo quotes',
      newQuote: 'New Quote',
      myQuotes: 'My Quotes',
      pendingQuotes: 'Pending Quotes',
      respondedQuotes: 'Responded Quotes',
      noQuotes: "You don't have any quotes",
      requestQuote: 'Request Quote',
      describeIdea: 'Describe your idea',
      descriptionPlaceholder: 'Describe the tattoo you want: design, meaning, references...',
      bodyPart: 'Body part',
      bodyPartPlaceholder: 'Ex: forearm, back, thigh...',
      approximateSize: 'Approximate size',
      sizePlaceholder: 'Ex: 10x10cm, half sleeve...',
      preferredStyle: 'Preferred style',
      sendRequest: 'Send Request',
      respondToQuote: 'Respond to Quote',
      priceRange: 'Price range',
      minPrice: 'Minimum price',
      maxPrice: 'Maximum price',
      estimatedSessions: 'Estimated sessions',
      estimatedHours: 'Estimated hours',
      messageToClient: 'Message to client',
      messagePlaceholder: 'Include details about the process, materials, etc.',
      sendQuote: 'Send Quote',
      acceptQuote: 'Accept Quote',
      rejectQuote: 'Reject',
      quoteAccepted: 'Quote Accepted',
      quoteRejected: 'Quote Rejected',
      waitingResponse: 'Waiting for artist response',
      priceLabel: 'Estimated price',
      sessionsLabel: 'Sessions',
      hoursLabel: 'Hours per session',
    },
    // Notifications
    notifications: {
      title: 'Notifications',
      markAllRead: 'Mark all as read',
      noNotifications: "You don't have notifications",
      viewMore: 'View more →',
    },
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      send: 'Send',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      confirm: 'Confirm',
      select: 'Select',
      optional: 'optional',
      required: 'required',
    },
    // Tattoo styles
    styles: {
      traditional: 'Traditional',
      neoTraditional: 'Neo-Traditional',
      realism: 'Realism',
      blackwork: 'Blackwork',
      dotwork: 'Dotwork',
      japanese: 'Japanese',
      tribal: 'Tribal',
      minimalist: 'Minimalist',
      watercolor: 'Watercolor',
      geometric: 'Geometric',
      chicano: 'Chicano',
      lettering: 'Lettering',
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('inker_language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('inker_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
